import request from '@/utils/queryIccidRequest'

export function getToken() {
  return request({
    url: '/tsim/sale_info_collection/qiniuUploadToken', 
    method: 'get'
  })
}
